import styles from '../CaseBuilderEnhanced.module.css';

export default function CaseLibraryTable({ cases, onRowClick, renderCompleteness }) {
    return (
        <div className={styles.panel}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>Network ID</th>
                        <th>Local ID</th>
                        <th>NACC</th>
                        <th>Slides</th>
                        <th>Status</th>
                        <th>Completeness</th>
                    </tr>
                </thead>
                <tbody>
                    {cases.map((c) => {
                        const id = c.networkIdentifier;
                        return (
                            <tr
                                key={id}
                                className={styles.tableRowClickable}
                                onClick={() => onRowClick(c)}
                            >
                                <td>{id}</td>
                                <td>{c.localIdentifier || '—'}</td>
                                <td>{c.naccId || '—'}</td>
                                <td>{c.slideCount ?? (Array.isArray(c.items) ? c.items.length : 0)}</td>
                                <td>
                                    {c.quarantined ? (
                                        <span className={`${styles.badge} ${styles.badgeQuarantine}`}>Quarantined</span>
                                    ) : (
                                        <span className={`${styles.badge} ${styles.badgeReady}`}>Released</span>
                                    )}
                                </td>
                                <td>{renderCompleteness ? renderCompleteness(c) : '—'}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
